export type ThemeMode = 'system' | 'light' | 'dark';

export function BrandMark({ size = 'sm' }: { size?: 'sm' | 'lg' }) {
  const classes = size === 'lg' ? 'brand-mark w-8 h-8 text-[15px]' : 'brand-mark w-6 h-6 text-[12px]';
  return <div className={classes}>F</div>;
}

export function ThemeToggle({
  value,
  onChange,
}: {
  value: ThemeMode;
  onChange: (theme: ThemeMode) => void;
}) {
  return (
    <div className="theme-toggle" aria-label="Theme">
      {(['system', 'light', 'dark'] as ThemeMode[]).map(mode => (
        <button
          key={mode}
          type="button"
          aria-pressed={value === mode}
          onClick={() => onChange(mode)}
        >
          {mode === 'system' ? 'Auto' : mode[0].toUpperCase() + mode.slice(1)}
        </button>
      ))}
    </div>
  );
}
